var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepotingManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#1D4469"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5461 6.879C11.5461 8.28484 10.4064 9.4245 9.00058 9.4245C7.59474 9.4245 6.45508 8.28484 6.45508 6.879C6.45508 5.47316 7.59474 4.3335 9.00058 4.3335C10.4064 4.3335 11.5461 5.47316 11.5461 6.879ZM10.8195 10.1049C11.5835 10.311 12.2224 10.5996 12.6234 10.8053C13.2673 11.1359 13.6675 11.7884 13.6675 12.5079V12.8184C13.6675 13.2864 13.2867 13.6669 12.819 13.6669H9.63712H8.36437H5.18249C4.71474 13.6669 4.33398 13.2864 4.33398 12.8184V12.5079C4.33398 11.7884 4.7342 11.1359 5.37806 10.8053C5.77909 10.5996 6.41795 10.311 7.18194 10.1049C7.2876 10.0753 7.39988 10.1341 7.43675 10.2381L8.30622 12.6638L8.56946 11.3472L8.16301 10.1279C8.14146 10.0633 8.15224 9.99198 8.19243 9.93667C8.2322 9.88137 8.296 9.84863 8.36437 9.84863H9.63712C9.70549 9.84863 9.76928 9.88137 9.80906 9.93667C9.84925 9.992 9.86001 10.0633 9.83847 10.1279L9.43203 11.3472L9.69527 12.6638L10.5647 10.2381C10.6016 10.1341 10.7135 10.0751 10.8195 10.1049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepotingManager);
export default __webpack_public_path__ + "static/media/RepotingManager.03d7ae2cf43c60c56706b5a80ca4d018.svg";
export { ForwardRef as ReactComponent };